import {
  SHOPIFY_SALES_CHANNEL_SUCCESS,
  SHOPIFY_SALES_CHANNEL_LOADING,
  } from '../actions/SalesByChannelAction';
  
  const initialState = {
    SalesByChannelData: [],
    isLoading: true
  };
  
  const SalesByChannelReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case SHOPIFY_SALES_CHANNEL_SUCCESS:
        return { ...state, SalesByChannelData: action.data, isLoading: false };
      case SHOPIFY_SALES_CHANNEL_LOADING:
        return { ...state, isLoading: action.isLoading };
      default:
        return state;
    }
  };
  
  export default SalesByChannelReducer;
  